import React from "react"
import { useForm } from "react-hook-form"
import { object, string } from "zod"
import { zodResolver } from "@hookform/resolvers/zod"
import { SMALL } from "constants/index"
import { Size } from "types/general.types"
import TextField from "components/atoms/TextField"
import SearchIcon from "components/atoms/_icons/SearchIcon"

const searchInputSchema = object({
  value: string()
})

type SearchInputProps = {
  id?: string;
  defaultValue?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: Size;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function SearchInput(props: SearchInputProps) {
  const {
    id,
    defaultValue = "",
    placeholder,
    disabled,
    size = SMALL,
    onChange
  } = props

  const {
    register,
    setValue,
    formState: { errors }
  } = useForm<{ value: string }>({
    resolver: zodResolver(searchInputSchema),
    shouldFocusError: false,
    reValidateMode: "onChange",
    defaultValues: {
      value: defaultValue
    }
  })

  return (
    <TextField
      id={id || "search-input"}
      label={""}
      size={size}
      startAdornmentIcon={<SearchIcon/>}
      mandatoryIcon={true}
      placeholder={placeholder}
      disabled={disabled}
      defaultValue={defaultValue}
      register={register}
      setValue={setValue}
      error={errors.value}
      onChange={onChange}
    />
  )
}
